export default __webpack_public_path__ + "static/stanholland-d0d93a885a2bc46db64435e5389187ff.png";